//개인정보처리방침
const personalInfoLink =
  "https://codime.notion.site/7f90427cb9e34d00bd64b9953ee3680f?pvs=4";
//서비스이용약관
const serviceLink =
  "https://codime.notion.site/3da4488519f44876b2a14824c1bd7614?pvs=4";
//개인정보처리방침 - 영어
const personalInfoLinkEn =
  "https://codime.notion.site/Privacy-Policy-1b20d0b43f6b80f9abfdfab6a17f10a9?pvs=4";
//서비스이용약관 - 영어
const serviceLinkEn =
  "https://codime.notion.site/Service-Terms-of-Use-1b20d0b43f6b80ea9bede343c44eab6a?pvs=4";

export { personalInfoLink, serviceLink, personalInfoLinkEn, serviceLinkEn };
